module.exports = __webpack_public_path__ + "static/media/200303_Boris_Nanista_01@2x.3123dfc2.png";